<template>
  <v-app>
    <top-bar @update="menu = !menu"></top-bar>

    <v-navigation-drawer
      v-if="shouldShowMenu"
      v-model="menu"
      floating
      :location="$vuetify.display.mobile ? 'bottom' : undefined"
      temporary
      :width="375"
    >
      <v-list density="compact" nav>
        <v-list-item
          v-if="hasSelectedCustomer"
          active-class="active-menu elevation-6"
          class="mt-5 title-menu"
          value="mes points"
          data-cy="menu-points"
          @click="pushView('points')"
        >
          <template v-slot:title>
            <span class="text-subtitle-1 font-egyptienne">
              {{ $t("menu.use-points") }}</span
            >
          </template>
          <template v-slot:prepend>
            <v-icon color="#feb100" :icon="mdiStarOutline" size="40"></v-icon>
          </template>
        </v-list-item>
        <v-list-item
          v-if="hasSelectedCustomer"
          active-class="active-menu elevation-6"
          class="mt-3 mb-3 title-menu"
          value="mes commandes programme one"
          data-cy="menu-commandes-one"
          @click="pushView('stryker-one-commands')"
        >
          <template v-slot:title>
            <span class="text-subtitle-1 font-egyptienne">
              {{ $t("menu.my-stryker-one-commands") }}
              <span class="one-color">{{ $t("one") }}</span>
            </span>
          </template>
          <template v-slot:prepend>
            <v-icon
              color="#feb100"
              :icon="mdiPackageVariant"
              size="40"
            ></v-icon>
          </template>
        </v-list-item>
        <v-list-item
          v-if="hasSelectedCustomer"
          active-class="active-menu elevation-6"
          class="mt-3 mb-3 title-menu"
          value="mes commandes stryker"
          data-cy="stryker-commands"
          @click="pushView('stryker-commands')"
        >
          <template v-slot:title>
            <span class="text-subtitle-1 font-egyptienne">
              {{ $t("menu.my-stryker-commands") }}</span
            >
          </template>
          <template v-slot:prepend>
            <v-icon
              color="#feb100"
              :icon="mdiPackageVariant"
              size="40"
            ></v-icon>
          </template>
        </v-list-item>
        <v-list-item
          v-if="hasSelectedCustomer"
          active-class="active-menu elevation-6"
          class="mt-3 mb-3 title-menu"
          value="Mon contrat"
          data-cy="menu-contrat"
          @click="pushView('contrat')"
        >
          <template v-slot:title>
            <span class="text-subtitle-1 font-egyptienne">
              {{ $t("menu.contrat") }}</span
            >
          </template>
          <template v-slot:prepend>
            <v-icon
              color="#feb100"
              :icon="mdiAccountBoxOutline"
              size="40"
            ></v-icon>
          </template>
        </v-list-item>
        <v-list-item
          v-if="hasSelectedCustomer"
          active-class="active-menu elevation-6"
          class="mt-3 mb-3 title-menu"
          value="Service Programme One"
          data-cy="menu-service"
          @click="pushView('service-one-stryker')"
        >
          <template v-slot:title>
            <span class="text-subtitle-1 font-egyptienne">
              {{ $t("menu.one-stryker-service") }}
              <span class="one-color">{{ $t("one") }}</span>
            </span>
          </template>
          <template v-slot:prepend>
            <v-icon color="#feb100" :icon="mdiCogOutline" size="40"></v-icon>
          </template>
        </v-list-item>
        <v-list-item
          v-if="hasSelectedCustomer"
          active-class="active-menu elevation-6"
          class="mt-3 mb-3 title-menu"
          value="contact"
          data-cy="menu-contact"
          @click="pushView('contact')"
        >
          <template v-slot:title>
            <span class="text-subtitle-1 font-egyptienne">
              {{ $t("menu.contact") }}</span
            >
          </template>
          <template v-slot:prepend>
            <v-icon color="#feb100" :icon="mdiForumOutline" size="40"></v-icon>
          </template>
        </v-list-item>
        <v-list-item
          v-if="isAdmin"
          active-class="active-menu elevation-6"
          class="mt-3 mb-3 title-menu"
          value="admin"
          @click="pushView('admin')"
        >
          <template v-slot:title>
            <span class="text-subtitle-1 font-egyptienne">
              {{ $t("menu.administration") }}</span
            >
          </template>
          <template v-slot:prepend>
            <v-icon color="#feb100" :icon="mdiDatabaseCog" size="40"></v-icon>
          </template>
        </v-list-item>
        <v-list-item
          v-if="isAdmin"
          active-class="active-menu elevation-6"
          class="mt-3 mb-3 title-menu"
          value="kpi"
          @click="pushView('kpi')"
        >
          <template v-slot:title>
            <span class="text-subtitle-1 font-egyptienne">
              {{ $t("menu.kpi") }}</span
            >
          </template>
          <template v-slot:prepend>
            <v-icon color="#feb100" :icon="mdiChartBar" size="40"></v-icon>
          </template>
        </v-list-item>
        <v-list-item
          v-if="isStaffOrAdmin"
          active-class="active-menu elevation-6"
          class="mt-3 mb-3 title-menu"
          value="projections"
          @click="pushView('projections')"
        >
          <template v-slot:title>
            <span class="text-subtitle-1 font-egyptienne">
              {{ $t("menu.projections") }}</span
            >
          </template>
          <template v-slot:prepend>
            <v-icon color="#feb100" :icon="mdiChartLine" size="40"></v-icon>
          </template>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>
    <v-main>
      <snackbar-component></snackbar-component>
      <router-view />
      <v-overlay :model-value="overlay" class="align-center justify-center">
        <v-progress-circular
          color="#ffb300"
          size="64"
          indeterminate
        ></v-progress-circular>
      </v-overlay>
    </v-main>
    <footer-component></footer-component>
  </v-app>
</template>

<script>
import FooterComponent from "./components/FooterComponent.vue";
import SnackbarComponent from "./components/SnackbarComponent.vue";
import TopBar from "./components/TopBar.vue";
import {
  mdiStarOutline,
  mdiPackageVariant,
  mdiAccountBoxOutline,
  mdiCogOutline,
  mdiForumOutline,
  mdiDatabaseCog,
  mdiChartBar,
  mdiChartLine,
} from "@mdi/js";
import { mapState } from "vuex";
import contractYear from "./mixins/contractYear";

export default {
  name: "App",
  mixins: [contractYear],
  components: {
    FooterComponent,
    TopBar,
    SnackbarComponent,
  },
  data() {
    return {
      menu: null,
      mdiStarOutline,
      mdiPackageVariant,
      mdiAccountBoxOutline,
      mdiCogOutline,
      mdiForumOutline,
      mdiDatabaseCog,
      mdiChartBar,
      mdiChartLine,
    };
  },
  computed: {
    ...mapState({
      overlay: (state) => state.overlay,
      customer: (state) => state.users.selectedCustomer.id,
      customerNumber: (state) => state.users.selectedCustomer,
      user: (state) => state.users.user,
      customers: (state) => state.users.customers,
    }),
    hasSelectedCustomer() {
      return this.customer !== -1;
    },
    isAdmin() {
      return this.user?.userRole?.toUpperCase() === "ADMIN";
    },
    isStaffOrAdmin() {
      return ["ADMIN", "REPS", "BUD", "RSM"].includes(
        this.user?.userRole?.toUpperCase(),
      );
    },
    shouldShowMenu() {
      const userRole = this.user?.userRole?.toUpperCase();
      const customers = this.customers || [];

      // Si l'utilisateur est REPS, BUD ou RSM sans client, ne pas afficher le menu
      if (["REPS", "BUD", "RSM"].includes(userRole) && customers.length === 0) {
        return false;
      }

      return true;
    },
  },
  methods: {
    pushView(view) {
      this.$store.commit("setOverlay", true);
      if (this.$route.name != view) {
        if (view === "stryker-commands" && this.customer !== -1) {
          this.$store.commit("strykerCommands/setItems", []);
          this.$store.dispatch(
            "strykerCommands/fetchCustommerCommands",
            this.customer,
          );
          const data = {
            id: this.customer,
            name: "",
          };
          this.$store
            .dispatch("statsCustomer/fetChSpecificStatsCustomer", data)
            .then(() => {
              this.$store.commit("setOverlay", false);
              this.$router.push({ name: view });
            })
            .catch(() => {
              this.$store.commit("setOverlay", false);
            });
        } else if (view === "points") {
          const dataToSend = {
            text: "?Customer=" + this.customer,
          };
          this.$store
            .dispatch("products/fetchProductForCustomer", dataToSend)
            .then((response) => {
              if (response.data == "No products found") {
                this.$store.dispatch("cart/fetchCartByCustomer", this.customer);
                this.$store.commit("setOverlay", false);
                this.$router.push({ name: view });
                return;
              } else {
                this.$store.dispatch("cart/fetchCartByCustomer", this.customer);
                this.$store.commit(
                  "paginations/setItems",
                  JSON.parse(response.headers.get("X-Pagination")),
                );
                this.$store.commit("setOverlay", false);
                this.$router.push({ name: view });
              }
            });
        } else if (view === "stryker-one-commands") {
          this.$store.commit("ordersOneStryker/setItems", []);
          const dataToFetch = {
            pagination: "",
            customer: this.customer,
          };
          this.$store
            .dispatch("ordersOneStryker/fetchCustommerCommands", dataToFetch)
            .then((response) => {
              this.$store.commit(
                "paginations/setItems",
                JSON.parse(response.headers.get("X-Pagination")),
              );
            });
          const data = {
            id: this.customer,
            name: "",
          };
          this.$store.dispatch(
            "statsCustomer/fetChSpecificStatsCustomer",
            data,
          );
          this.$store.commit("setOverlay", false);
          this.$router.push({ name: view });
        } else if (view === "contrat") {
          this.$store
            .dispatch("files/getFilesForSpecificCustomer", this.customer)
            .then(() => {
              this.$store.commit("setOverlay", false);
              this.$router.push({ name: view });
            })
            .catch(() => {
              this.$store.commit("setOverlay", false);
              this.$store.dispatch("showSnackbar", {
                message: this.$t("alert.error.contract-files"),
                color: "error",
              });
            });
        } else if (view == "kpi") {
          // Appel de la statistique KPI avec l'année contractuelle
          this.$store
            .dispatch("kpi/fetchStatistics", {
              year: this.currentYear,
              month: null,
            })
            .then(() => {
              this.$store.commit("setOverlay", false);
              this.$router.push({ name: view });
            })
            .catch(() => {
              this.$store.commit("setOverlay", false);
              this.$store.dispatch("showSnackbar", {
                message: this.$t("alert.error.kpi-statistics"),
                color: "error",
              });
            });
        } else if (view == "contact") {
          this.$store
            .dispatch("clients/getUniqueContactDetails", this.customer)
            .then(() => {
              this.$store.commit("setOverlay", false);
              this.$router.push({ name: view });
            })
            .catch(() => {
              this.$store.commit("setOverlay", false);
              this.$router.push({ name: view });
            });
        } else {
          this.$store.commit("setOverlay", false);
          this.$router.push({ name: view });
        }
      } else {
        this.$store.commit("setOverlay", false);
      }
    },
  },
};
</script>

<style>
.active-menu {
  border-left: 4px solid #feb100;
  border-top-left-radius: 6px; /* Round the top-left corner */
  border-bottom-left-radius: 6px; /* Round the bottom-left corner */
}

.title-menu {
  color: black;
  font-size: 1rem !important;
}

.align-icon-right {
  text-align: right;
}

.one-color {
  color: #ffb500;
}

@font-face {
  font-family: "Futura LT W01";
  font-weight: 400;
  src: url("@/fonts/Futura LT W01-400.woff2") format("woff2");
}

@font-face {
  font-family: "Futura LT W01";
  font-weight: 700;
  src: url("@/fonts/Futura LT W01-700.woff2") format("woff2");
}

@font-face {
  font-family: "HumanistSlab712W01";
  font-weight: 400;
  src: url("@/fonts/HumanistSlab712W01-400.woff2") format("woff2");
}

@font-face {
  font-family: "HumanistSlab712W01";
  font-weight: 700;
  src: url("@/fonts/HumanistSlab712W01-400.woff2") format("woff2");
}

@font-face {
  font-family: "URWEgyptienneW01-Light";
  font-weight: 400;
  src: url("@/fonts/URWEgyptienneW01-Light-400.woff2") format("woff2");
}
</style>
